import { createQueryKeyStore } from "@lukemorales/query-key-factory";

import type { UseRecentlyPharmacyWithDeliveryAreasQueryArgs } from "../hooks/integratedCounseling/useRecentlyPharmacyWithDeliveryAreasQuery";
import type { UseAllPharmaciesQueryArgs } from "../hooks/pharmacy/useAllPharmaciesQuery";
import type { UsePharmaciesByChainQueryArgs } from "../hooks/pharmacy/usePharmaciesByChainQuery";
import type { UseSearchPharmaciesQueryArgs } from "../hooks/pharmacy/useSearchPharmaciesQuery";
import type { UseSearchPharmacyFromExternalIdQueryArgs } from "../hooks/pharmacy/useSearchPharmacyFromExternalIdQuery";

export const pharmacyKeys = createQueryKeyStore({
  pharmacy: {
    detail: (pharmacyId: string) => [pharmacyId],
    byIds: (serializedPharmacyIds: string) => [serializedPharmacyIds],
  },
  all: {
    list: (args: UseAllPharmaciesQueryArgs) => [args],
  },
  byChain: {
    list: (args: UsePharmaciesByChainQueryArgs) => [args],
  },
  search: {
    list: (args: UseSearchPharmaciesQueryArgs) => [args],
  },
  searchExternalId: {
    list: (args: UseSearchPharmacyFromExternalIdQueryArgs) => [args],
  },
  recentlyWithDeliveryAreas: {
    detail: (args: Omit<UseRecentlyPharmacyWithDeliveryAreasQueryArgs, "isEnabled">) => [args],
  },
  favoriteWithDeliveryAreas: {
    list: (args: { pharmacyIds: number[]; postalCode: string | undefined }) => [args],
  },
});
